import { lazy } from "react";

/**
 * @description Lazily load the `AppLayout` component
 *
 * {@link https://react.dev/reference/react/lazy#suspense-for-code-splitting 🔗 Lazy Loading components with Suspense}
 */
export const AppLayoutAsync = lazy(async function () {
  return import("./AppLayout").then((module) => ({ default: module.AppLayout }));
});
